import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-md-center pdb-20 flex-md-row flex-column gap-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, " Info Change Request ", -1)
const _hoisted_4 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_5 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100" }
const _hoisted_6 = { class: "d-flex gap-4 col-md-6 col-12" }
const _hoisted_7 = {
  key: 1,
  class: "small striped toggle no-underline"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " NBF Participant ID "),
    /*#__PURE__*/_createElementVNode("th", null, " First Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Last Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Web Submission Date "),
    /*#__PURE__*/_createElementVNode("th", null, " Request Type "),
    /*#__PURE__*/_createElementVNode("th", null, " Status ")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "cell col-md-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: ""
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " No requests have been found")
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertComponent, {
      success: $setup.success,
      error: $setup.error
    }, null, 8, ["success", "error"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-primary w-sm-100",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.exportToExcel && $setup.exportToExcel(...args)))
        }, _toDisplayString($setup.loadingExport ? 'Exporting...' : 'Export To Excel'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SelectComponent, {
              defaultOption: { key: 0, value: 'Request Type' },
              "onUpdate:options": $setup.handleRequestType,
              options: $setup.requestTypes,
              "single-arrow": true,
              type: "filters",
              customClass: "fs-xs"
            }, null, 8, ["onUpdate:options", "options"]),
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.Status,
              "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.Status) = $event)),
              options: $setup.statuses,
              "single-arrow": true,
              customClass: "fs-xs"
            }, null, 8, ["selectedOption", "options"])
          ]),
          _createVNode(_component_TextInput, {
            type: "text",
            name: "mixed",
            placeholder: "Search by ID or Name...",
            max: 30,
            modelValue: $setup.filters.Search,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.Search) = $event)),
            customClass: "search col-md-4 col-sm-6"
          }, null, 8, ["modelValue"])
        ]),
        ($setup.loading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock("table", _hoisted_7, [
              _hoisted_8,
              ($setup.requests && $setup.requests.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.requests, (request) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "large",
                        key: request.UIAdminID
                      }, [
                        _createElementVNode("td", {
                          class: "plan-modal",
                          onClick: ($event: any) => ($setup.reviewRequest(request.UIAdminID, 'Review ' + request.RequestType))
                        }, [
                          _createElementVNode("a", {
                            href: "javascript;",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                          }, _toDisplayString(request.PersonID), 1)
                        ], 8, _hoisted_10),
                        _createElementVNode("td", null, _toDisplayString(request.FirstName), 1),
                        _createElementVNode("td", null, _toDisplayString(request.LastName), 1),
                        _createElementVNode("td", null, _toDisplayString(request.WebSubmissionDate), 1),
                        _createElementVNode("td", null, _toDisplayString(request.RequestType), 1),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("small", {
                            class: _normalizeClass(["label label_small label_green_secondary w-fit", { 'label_danger_secondary': request.Status == 'Denied', 'label_blue': request.Status == 'Pending' }])
                          }, [
                            _hoisted_12,
                            _createTextVNode(" " + _toDisplayString(request.Status), 1)
                          ], 2)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_13, _hoisted_15))
            ]))
      ]),
      ($setup.requests && $setup.requests.length > 0 && !$setup.loading)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 0,
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}